import {HTTP} from '@/services/HttpServices';
import {Form, FormSection, FormSectionField, FormSectionFieldValue, FormUpload} from '@/custom-forms/admin/FormModels';
import {DocusignAccount} from '@/custom-forms/admin/DocusignModel';

const FORM_PATH = '/admin/forms';
const FORM_SECTION_PATH = '/admin/form-sections';
const FORM_SECTION_FIELD_PATH = '/admin/form-section-fields';
const FORM_SECTION_FIELD_VALUE_PATH = '/admin/form-section-field-values';
const FORM_UPLOAD_PATH = '/admin/form-uploads';
const DOCUSIGN_ACCOUNTS_PATH = '/admin/docusign-accounts';

export async function listForms(): Promise<Form[]> {
    return await HTTP.get(FORM_PATH);
}

export async function getFormById(id: string): Promise<Form> {
    return await HTTP.get(`${FORM_PATH}/${id}`);
}

export async function copyForm(id: string): Promise<Form> {
    return await HTTP.post(`${FORM_PATH}/${id}/copy`);
}

export async function createForm(form: Form): Promise<any> {
    return await HTTP.post(FORM_PATH, form);
}

export async function updateForm(form: Form) {
    return await HTTP.put(`${FORM_PATH}/${form.id}`, form);
}

export async function deleteForm(id: string) {
    return await HTTP.httpDelete(`${FORM_PATH}/${id}`);
}

export async function listFormSections(formId: number): Promise<FormSection[]> {
    return await HTTP.get(`${FORM_SECTION_PATH}?formId=${formId}`);
}


export async function createFormSection(formSection: FormSection): Promise<any> {
    return await HTTP.post(FORM_SECTION_PATH, formSection);
}

export async function updateFormSection(formSection: FormSection) {
    return await HTTP.put(`${FORM_SECTION_PATH}/${formSection.id}`, formSection);
}

export async function deleteFormSection(id: string) {
    return await HTTP.httpDelete(`${FORM_SECTION_PATH}/${id}`);
}

export async function reorderFormSections(formId: number, formSectionOrders: {id: number, sequence: number}[]): Promise<any> {
    return await HTTP.post(`${FORM_SECTION_PATH}/reorder`, {formId, newOrder: formSectionOrders});
}

export async function listFormSectionFields(formSectionId: number): Promise<FormSectionField[]> {
    return await HTTP.get(`${FORM_SECTION_FIELD_PATH}?formSectionId=${formSectionId}`);
}

export async function createFormSectionField(formSectionField: FormSectionField): Promise<any> {
    return await HTTP.post(FORM_SECTION_FIELD_PATH, formSectionField);
}

export async function updateFormSectionField(formSectionField: FormSectionField) {
    return await HTTP.put(`${FORM_SECTION_FIELD_PATH}/${formSectionField.id}`, formSectionField);
}

export async function deleteFormSectionField(id: string) {
    return await HTTP.httpDelete(`${FORM_SECTION_FIELD_PATH}/${id}`);
}

export async function reorderFormSectionFields(formSectionId: number, formSectionFieldOrders: {id: number, sequence: number}[]): Promise<any> {
    return await HTTP.post(`${FORM_SECTION_FIELD_PATH}/reorder`, {formSectionId, newOrder: formSectionFieldOrders});
}

export async function listFormSectionFieldValues(formSectionFieldId: number): Promise<FormSectionFieldValue[]> {
    return await HTTP.get(`${FORM_SECTION_FIELD_VALUE_PATH}?formSectionFieldId=${formSectionFieldId}`);
}

export async function createFormSectionFieldValue(formSectionField: FormSectionFieldValue): Promise<any> {
    return await HTTP.post(FORM_SECTION_FIELD_VALUE_PATH, formSectionField);
}

export async function updateFormSectionFieldValue(formSectionField: FormSectionFieldValue) {
    return await HTTP.put(`${FORM_SECTION_FIELD_VALUE_PATH}/${formSectionField.id}`, formSectionField);
}

export async function deleteFormSectionFieldValue(id: string) {
    return await HTTP.httpDelete(`${FORM_SECTION_FIELD_VALUE_PATH}/${id}`);
}

export async function reorderFormSectionFieldValues(formSectionId: number, formSectionFieldValueOrders: {id: number, sequence: number}[]): Promise<any> {
    return await HTTP.post(`${FORM_SECTION_FIELD_VALUE_PATH}/reorder`, {formSectionId, newOrder: formSectionFieldValueOrders});
}

export async function listFormUploads(formId: number): Promise<FormUpload[]> {
    return await HTTP.get(`${FORM_UPLOAD_PATH}/?formId=${formId}`);
}

export async function createFormUpload(formUpload: FormUpload): Promise<any> {
    return await HTTP.post(FORM_UPLOAD_PATH, formUpload);
}

export async function updateFormUpload(formUpload: FormUpload) {
    return await HTTP.put(`${FORM_UPLOAD_PATH}/${formUpload.id}`, formUpload);
}

export async function deleteFormUpload(id: string) {
    return await HTTP.httpDelete(`${FORM_UPLOAD_PATH}/${id}`);
}

export async function reorderFormUploads(formId: number, FormUploadOrders: {id: number, sequence: number}[]): Promise<any> {
    return await HTTP.post(`${FORM_UPLOAD_PATH}/reorder`, {formId, newOrder: FormUploadOrders});
}

export async function getDocusignAccounts(): Promise<DocusignAccount[]> {
    return await HTTP.get(`${DOCUSIGN_ACCOUNTS_PATH}`);
}
